exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.divBox[data-v-0c806283] {\n  padding: 20px;\n}\n.box-card[data-v-0c806283] {\n  border: none;\n}\n.rule-section[data-v-0c806283] {\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n.rule-desc[data-v-0c806283] {\n  line-height: 1.6;\n}\n", ""]);

// exports
